<template>
  <div class="">
    <Grid
      v-bind:style="{ height: gridHeight + 'px' }"
      :data-items="fileIem"
      @download="download"
      @remove="remove"
      @view="view"
      :columns="FileUploadcolumns"
    >
      <grid-toolbar>
        <div class="text-right">
          <button type="button" @click="uploadFile" class="k-button k-primary">
            Add File
          </button>
        </div>
      </grid-toolbar>
    </Grid>
    <kendo-window
      ref="windowRef"
      :width="'600px'"
      :title="'Upload File'"
      :modal="true"
      style="display:none"
    >
      <div class>
        <kendo-upload
          ref="upload"
          name="files"
          :async-save-url="'custom-save-url'"
          :async-remove-url="'custom-remove-url'"
          :async-auto-upload="false"
          :multiple="false"
          :template="template"
        ></kendo-upload>
      </div>
    </kendo-window>
  </div>
</template>
<script>
import Vue from "vue";
import CommandCell from "@/components/FileUploadCell/FileUploadCell.vue";
import { UploadInstaller } from "@progress/kendo-upload-vue-wrapper";
Vue.use(UploadInstaller);
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("driver");
export default {
  data: function() {
    return {
      gridHeight: window.innerHeight - 150,
      driverData: {},
      FileUploadcolumns: [
        { field: "id", title: "S.No" },
        { field: "fileName", title: "File Name" },
        { field: "fileUrl", title: "File URL" },
        { field: "fileType", title: "File Type" },
        { cell: CommandCell, title: "Actions", width: "300px" },
      ],
      files: [],
      template:
        "<span class='k-progress'></span>" +
        "<div class='file-wrapper'>" +
        "<span class='file-icon img-file'></span>" +
        "<h4 class='file-heading file-name-heading'>Name: #=name#</h4>" +
        "<h4 class='file-heading file-size-heading'>Size: #=size# bytes</h4>" +
        "<strong class='k-upload-status'>" +
        "<button type='button' " +
        "class='k-upload-action'></button>" +
        "<button type='button' class='k-upload-action'></button>" +
        "</strong>" +
        "</div>",
    };
  },
  methods: {
    async view(e) {
      this.$store.dispatch("driver/viewFile", e.dataItem.id).then(() => {
        const fileUrl = this.$store.getters["driver/fileUrlView"];
        window.open(fileUrl, "_blank");
      });
    },
    download: function(e) {
      this.$store.dispatch("driver/downloadFile", e.dataItem.id).then(() => {
        const fileUrl = this.$store.getters["driver/fileUrlDownload"];
        window.open(fileUrl, "_blank");
      });
    },
    remove: function(e) {
      this.$store.dispatch("driver/deleteFile", e.dataItem.id).then(() => {
        this.$store.dispatch("driver/getDriverFileList", this.driverData.id);
      });
    },
    uploadFile() {
      var window = this.$refs.windowRef.kendoWidget();
      window.center().open();
      this.fileUpload();
    },
    fileUpload() {
      //var t = this;
      var postFormData = function(url, data, fileEntry, xhr) {
         let dataArray = []
        dataArray.push(data)
        // t.$store
        //   .dispatch("driver/uploadFile", {
        //     data: data,
        //     id: t.driverData.id,
        //   })
        //   .then(() => {
        //     t.$store.dispatch("driver/getDriverFileList", t.driverData.id);
        //     t.fileClose();
        //     t.upload._submitRemove = t.submitRemove;
        //   });
        var module = this;
        fileEntry.data("request", xhr);

        setTimeout(function() {
          var e = {
            target: { responseText: "", statusText: "OK", status: 200 },
          };
          module.onRequestSuccess.call(module, e, fileEntry);
        }, 1000);
      };
      var submitRemove = function(fileNames, eventArgs, onSuccess) {
        onSuccess();
      };

      var upload = this.$refs.upload.kendoWidget();
      upload._module.postFormData = postFormData;
      upload._submitRemove = submitRemove;
    },
    fileClose() {
      var window = this.$refs.windowRef.kendoWidget();
      window.center().close();
    },
  },
  computed: {
    ...mapState({
      fileIem: (state) => state.driverFileList,
    }),
  },
  beforeMount() {
    this.driverData = this.$store.getters["driver/drvr"];
    if (this.driverData.id !== undefined) {
      this.$store.dispatch("driver/getDriverFileList", this.driverData.id);
    }
  },
};
</script>
